var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25171 6.59668H1.60198L3.29917 19.4905C3.33753 19.7821 3.58604 20 3.88011 20H14.1198C14.4138 20 14.6623 19.7821 14.7007 19.4905L16.3979 6.59668H16.7481C17.0717 6.59668 17.3341 6.33434 17.3341 6.01074V3.44711C17.3341 3.12352 17.0717 2.86117 16.7481 2.86117H11.7342V2.63027C11.7342 1.17996 10.5542 0 9.10393 0H8.89593C7.44561 0 6.26565 1.17996 6.26565 2.63027V2.86117H1.25171C0.928115 2.86117 0.665771 3.12352 0.665771 3.44711V6.01074C0.665771 6.33434 0.928076 6.59668 1.25171 6.59668ZM13.6059 18.8281H4.39393L2.78397 6.59668H15.2159L13.6059 18.8281ZM7.43749 2.63027C7.43749 1.82613 8.09175 1.17188 8.89589 1.17188H9.10389C9.90803 1.17188 10.5623 1.82613 10.5623 2.63027V2.86117H7.43749V2.63027ZM1.83765 4.03305H16.1622V5.4248C16.0369 5.4248 1.9939 5.4248 1.83765 5.4248V4.03305Z",
    fill: "#613D2B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.20ed535effdcd126eb3b8f8189020150.svg";
export { ForwardRef as ReactComponent };